import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { ProposedPlants, CO2BetterServedReportFilters } from "./types/CO2BetterServedReport";
import { GlobalIndustrySegments, CO2MapBySapPlantReportFilters, CO2MapBySapPlantReportAllData, OtherPlantData } from "./types/CO2MapBySAPPlant";
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class CO2ReportsService {

    constructor(protected http: HttpClient) {
    }

    baseurl = environment.apiBaseUrl + 'CO2Reports/';

    getallproposedplants() {
        return this.http.get<ProposedPlants[]>(this.baseurl + "getallproposedplants");
    }

    getCO2BetterServedreportData(data: CO2BetterServedReportFilters) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
        return this.http.post<any[]>(this.baseurl + 'getco2betterservedreportdata', JSON.stringify(data, null, 2), httpOptions);
    }

    getUserCountries(apexId: string, isIGAdmin: boolean, isPowerUser: boolean, forAmerica: boolean, forEurope: boolean, forAsia: boolean, onlyDnB: boolean, onlySAP: boolean): Observable<any> {
        return this.http.get<any>(environment.apiBaseUrl + `locationsnapshot/usercountries?apexId=${apexId}&isIGAdmin=${isIGAdmin}&isPowerUser=${isPowerUser}&forAmerica=${forAmerica}&forEurope=${forEurope}&forAsia=${forAsia}&onlyDnB=${onlyDnB}&onlySAP=${onlySAP}`);
    }

    getglobalindustrysegments() {
        return this.http.get<GlobalIndustrySegments[]>(environment.apiBaseUrl + "IndustryCodes/getglobalindustrysegments");
    }

    getallplantsforcountries(countryids: string[], isPowerUser: boolean) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
        let data = {
            countryids: countryids,
            isPowerUser: isPowerUser
        }
        return this.http.post<ProposedPlants[]>(this.baseurl + 'getallplantsforcountries', JSON.stringify(data, null, 2), httpOptions);
    }

    getCO2MapBySAPReport(filters: CO2MapBySapPlantReportFilters): Observable<CO2MapBySapPlantReportAllData> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
        return this.http.post<CO2MapBySapPlantReportAllData>(this.baseurl + 'getco2mapbysapreportdata', JSON.stringify(filters, null, 2), httpOptions);
    }

    getallotherplants(miles, plants) {
        let plantstr: string;
        plants.forEach(element => {
            plantstr = plantstr + element + ",";
        });
        plantstr = plantstr.substring(0, plantstr.length - 2);
        return this.http.get<OtherPlantData>(this.baseurl + 'getallassplants/' + miles + "/" + plants);
    }

}